import { render } from "./FlightBuy.vue?vue&type=template&id=011af08a"
import script from "./FlightBuy.vue?vue&type=script&lang=js"
export * from "./FlightBuy.vue?vue&type=script&lang=js"
script.render = render

export default script